module.exports = [{"type":"title","text":"2024-10-16"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USD-M WebSocket Service: Added 'Incremental Depth Push' feature"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-10-16.json
// module id = OleB
// module chunks = 3